import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {MatList, MatListItem} from '@angular/material/list';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {MatLine} from '@angular/material/core';
import {NgForOf, NgIf} from '@angular/common';
import {MatButton} from '@angular/material/button';
import {UserService} from '@services/user/user.service';
import {LoginService} from '@services/login/login.service';

@Component({
  selector: 'app-sidebar',
  imports: [
    MatList,
    RouterLink,
    MatListItem,
    RouterLinkActive,
    MatLine,
    NgIf,
    NgForOf,
    MatButton
  ],
  templateUrl: './sidebar.component.html',
  standalone: true,
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  @Input() isExpanded: boolean = true;
  @Output() toggleMenu = new EventEmitter();

  private userService = inject(UserService);
  private loginService = inject(LoginService);

  public routeLinks = [
    {
      link: "doctors",
      name: "Doctors",
      icon: "assets/icons/doctor.png"
    },
    {
      name: 'Products',
      icon: 'assets/icons/cream.png',
      link: 'products'
    },
    {
      name: 'Requests',
      icon: 'assets/icons/shape.png',
      link: 'requests'
    },
    {
      name: 'Organization',
      icon: 'assets/icons/organization.png',
      link: 'organization'
    },
    {
      name: 'B2C Operations',
      icon: 'assets/icons/organization.png',
      link: 'b2c'
    },
    {
      name: 'Audit',
      icon: 'assets/icons/shape.png',
      link: 'audit'
    }
  ];

  get visibleRouteLinks() {
    return this.loginService.getUserRole() === 'ANNOTATOR'
      ? this.routeLinks.filter(route => route.link === 'requests')
      : this.routeLinks;
  }

  logout() {
    this.userService.logout();
  }
}
